<template>
	<div class="menu-item-row-container" :class="getStyleClasses" @click="handleRowClick">
		<div class="item-detail-info">
			<div class="image-wrapper">
				<menu-item-image :item="item" />
			</div>
			<div class="info-wrapper">
				<h1>{{ item.name }}</h1>
				<p v-html="item.description" :class="truncateForMobile()"></p>
			</div>
		</div>
	</div>
</template>

<script>
	import MenuItemImage from '@/components/menu/MenuItem/MenuItemImage';
	import menuItemMixin from '@Mixin/menuItemMixin';
	// TODO make more customizable with class "types"
	export default {
		components: {
			'menu-item-image': MenuItemImage,
		},
		mixins: [menuItemMixin],
		props: {
			item: {
				image: String,
				name: String,
				desciption: String,
			},
			linked: {
				type: Boolean,
				default: false,
			},
			hasDiscount: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			getStyleClasses() {
				if (this.linked) {
					return 'container--linked';
				}
				return '';
			},
		},
		methods: {
			handleRowClick() {
				if (this.linked) {
					const route = this.getItemRoute(this.item);
					route.params.edit = this.isEdited;
					
					if (this.hasDiscount) {
						route.params.hasDiscount = this.hasDiscount;
					}
					this.$router.push(route);
				}
			},
			truncateForMobile() {
				if (this.$mq === 'mobile') {
					return 'truncate';
				}
				return '';
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';

	.menu-item-row-container {

		&.container--linked {
			cursor: pointer;
		}

		.item-detail-info {
			display: flex;
			border-radius: 1rem;
			margin-bottom: 1rem;
			padding: 0.5rem;
			
			background-color: $offerHighlight;
			.image-wrapper {
				flex: 1;
				margin-right: 1em;
			}
			.info-wrapper {
				flex: 3;
				margin-right: 0.2rem;
				h1 {
					font-weight: bold;
				}
				p {
					font-size: 0.8rem;
				}
			}
		}
	}
	
	@include desktop {
		.offer-wrapper {
			.menu-item-row-container {
				background-color: $offerTextColor;
				.item-detail-info {
					background-color: $landingPageBackground;
					border: 1px solid;
					border-style: dashed;
					&:hover {
						background-color: $greyBackground;
					}
				}
			}
		}
	}
	@include mobile {
		.upsell-container{
			.menu-item-row-container {
				.item-detail-info {
					align-items: center;
					padding-bottom: 1em;
					border-radius: 0;
					border-bottom: 1px solid $greyOutline;
					margin-bottom: 0;
					background-color: $landingPageBackground;
					.info-wrapper {
						margin-left: 1em;
						margin-right: 1em;
						h1 {
							font-size: 1.3rem;
							color: $storeButtonColor;
						}
					}
					.image-wrapper {
						margin-right: 0;
					}
				}
			}
		}
		.menu-item-row-container {
			.item-detail-info {
				max-height: 100px;
				.image-wrapper {
					max-width: 120px;
					img {
						max-height: 100%;
					}
				}
				.info-wrapper {
					max-width: 60vw;
				}
			}
		}
		.offer-item {
			.menu-item-row-container {
				.item-detail-info {
					max-height: auto;
					flex-direction: row;
					.image-wrapper {
						margin: auto;
						img {
							max-height: 120px;
						}
					}
					.info-wrapper {
						margin: 0.5em;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/menu/common/MenuItemRow.vue